import { render, staticRenderFns } from "./ManageCampaigns.vue?vue&type=template&id=36e2fbec&scoped=true"
import script from "./ManageCampaigns.vue?vue&type=script&lang=js"
export * from "./ManageCampaigns.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=36e2fbec&prod&scoped=true&lang=css&external"
import style1 from "./ManageCampaigns.vue?vue&type=style&index=1&id=36e2fbec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e2fbec",
  null
  
)

export default component.exports